import React, {PureComponent} from 'react';

class CustomerProductAdd extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            selected: false,
            prodId: '',
            prodScore: '',
            step: 1,
            addNode:'true',
            selectPick:'none',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleEditNoteEdit = this.handleEditNoteEdit.bind(this);
        this.handleChangePickSelect = this.handleChangePickSelect.bind(this);
        this.handleEsthetType = this.handleEsthetType.bind(this);

    }


    componentDidMount(){
        try {
            this.refs[this.props.rowNumber +"pickNone"].checked=true;
        } catch (error) {
            console.error(error);
        }
      
    }

    handleInputChange(e) {
        e.preventDefault();
        e.stopPropagation();
        try {
            if(e.target.value.indexOf(" ") != -1 ){
                alert("Please remove the space in your product ID.");
                return false;
            }
        } catch (error) {
            alert(error);
        }
       
        this.setState({ [e.target.name]: e.target.value});
        if (e.target.name === "prodId") this.props.handleAddProductInputChange(e.target.value);
        else this.props.handleAddProductInputChangeScore(e.target.value);
    }

    handleConfirm = () => {
        // let step = this.state.step;
        // if (step === 1) {
        //     step++;
        //     this.setState({ step: step });
        // } else {
        //     this.props.addToProductArray();
        // }

       let isEstheticianPick = false;
       if(this.state.selectPick == 'esthetician'){
        isEstheticianPick = true;
       }
        this.props.addToProductArray(isEstheticianPick,this.state.estheticianNodeValue);
    }

    handleBack = () => {
        let step = this.state.step;
        step--;
        this.setState({ step: step });
    }

    handleEditNoteEdit(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value },()=>{
            if(name == "addNode" && value == "false"){
                this.setState({estheticianNodeValue:''});
            }
        });
    }

    handleChangePickSelect(e){
        let value = e.target.value;
        this.setState({
            selectPick:value
        },()=>{
            if(value == "esthetician"){
                try {
                    this.refs[this.props.rowNumber +"addNode"].checked=true;
                } catch (error) {
                    console.error(error);
                }
                
            }
        })
    }

    handleEsthetType(e){
        let value = e.target.value;
        this.setState({
            addNode:value
        });
    }
   

    render() {
        return (
                <div className="user-product-container" >
                    <div style={this.props.rowSelected ? { cursor:"pointer" } : null} className={ this.state.selected ? "user-product editing add-product" : "user-product add-product" } >
                        <h3>Add</h3>
                            <div className="add-content">
                                <input type="text" name="prodId" value={ this.state.prodId} placeholder="Product ID" onChange={ this.handleInputChange } />
                            </div> 
                            <div className="add-content">
                                <input type="text" name="prodScore" value={ this.state.prodScore } placeholder="Product Score" onChange={ this.handleInputChange } />
                            </div>

                            <div className="select-picks-content">
                                <ul className="select-picks-content-ul">
                                    <li>
                                        <label><input type="radio" value="esthetician" name= {this.props.rowNumber+"selectPick"} onChange={this.handleChangePickSelect}></input> Esthetician’s pick</label>
                                        <div className="inputNode_area" style={this.state.selectPick == 'esthetician' ? {display:'block'}:{display:'none'}}>
                                            <label>
                                                <input type="radio" name={this.props.rowNumber+"addNode"}  value='false' onChange={this.handleEsthetType}></input>
                                                No notes
                                            </label>
                                            <label>
                                                <input type="radio" ref={this.props.rowNumber +"addNode"} name={this.props.rowNumber+"addNode"} value= 'true' onChange={this.handleEsthetType}></input>
                                                Add notes
                                            </label>

                                            <div style={this.state.addNode == 'true' ? {display:'block'}:{display:'none'}  }>
                                                <textarea onChange={this.handleEditNoteEdit} name="estheticianNodeValue" value={this.state.estheticianNodeValue} className="inputNode_area_textArea paragraphRegular4"></textarea>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <label><input ref={this.props.rowNumber +"pickNone"} onChange={this.handleChangePickSelect} type="radio" value="none" name= {this.props.rowNumber+"selectPick"}></input> None</label>
                                    </li>
                                </ul>
                            </div>


                        
                        <div className="add-buttons">
                            {/* { this.state.step === 2 ? <button className="back" onClick={ this.handleBack } >Back</button> : null } */}
                            <button onClick={ this.handleConfirm } >Confirm</button>
                        </div>
                    </div>
                </div>
        );
    }
}

export default CustomerProductAdd;



// WEBPACK FOOTER //
// ./src/components/customersuccessportal/CustomerProductAdd.js